
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"27","viewBox":"0 0 32 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.625 5.594c0 .176.105.281.281.281h7.313c.14 0 .281-.105.281-.281V4.469c0-.14-.14-.282-.281-.282H4.906a.277.277 0 00-.281.282v1.125zm.281 3.093h7.313c.14 0 .281-.105.281-.28V7.28c0-.14-.14-.281-.281-.281H4.906a.277.277 0 00-.281.281v1.125c0 .176.105.281.281.281zm10.512 5.626c.246-.036.457-.282.457-.563V.812c0-.28-.281-.562-.563-.562H2.938A2.798 2.798 0 00.124 3.063v12.374a2.777 2.777 0 002.813 2.813h12.374a.578.578 0 00.563-.563v-.562a.561.561 0 00-.457-.527c-.176-.457-.176-1.828 0-2.285zm-1.441 0c-.106.632-.106 1.652 0 2.25H2.937a1.11 1.11 0 01-1.124-1.125c0-.598.492-1.126 1.125-1.126h11.039zm.21-12.376v10.688H2.938c-.421 0-.808.105-1.124.246V3.062c0-.597.492-1.124 1.125-1.124h11.25z","fill":"#121131"}})])
          )
        }
      }
    